import React from 'react';
import { components } from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './multiValueLabelTooltip.css';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
function CustomMultiValueLabel(props) {
  const {
    getFilterTooltip,
    handleMultiValueClick,
    data,
  } = props;
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={(
        <Tooltip id="multival-tooltip">
          {getFilterTooltip(data.value)}
        </Tooltip>
          )}
    >
      <div
        style={{ cursor: 'pointer' }}
        data-testid="custom-multival-label"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => handleMultiValueClick(e, data.value)}
      >
        <components.MultiValueLabel {...props} />
      </div>
    </OverlayTrigger>

  );
}

CustomMultiValueLabel.propTypes = {
  getFilterTooltip: PropTypes.func.isRequired,
  handleMultiValueClick: PropTypes.func.isRequired,
  data: PropTypes.shape({ value: PropTypes.number }).isRequired,
};
export default CustomMultiValueLabel;
